import {
  Box,
  Button,
  FormControl,
  Grid,
  IconButton,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import PropTypes from "prop-types";

const notificationUnits = ["Minutes", "Hours", "Days", "Weeks"];

const NotificationList = ({
  notifications,
  onNotificationChange,
  onRemoveNotification,
  onAddNotification,
}) => {
  return (
    <>
      {notifications.map((notification) => (
        <Grid item xs={12} key={notification.id}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1.5,
            }}
          >
            <TextField
              type="number"
              size="small"
              value={notification.amount}
              onChange={(e) =>
                onNotificationChange(
                  notification.id,
                  "amount",
                  Number(e.target.value) || 0
                )
              }
              sx={{ width: 72 }}
            />
            <FormControl size="small" sx={{ minWidth: 96 }}>
              <Select
                value={notification.unit}
                onChange={(e) =>
                  onNotificationChange(notification.id, "unit", e.target.value)
                }
              >
                {notificationUnits.map((unit) => (
                  <MenuItem key={unit} value={unit}>
                    {unit}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Typography color="textSecondary" sx={{ minWidth: 80 }}>
              Before at
            </Typography>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <TimePicker
                value={notification.time}
                onChange={(value) =>
                  onNotificationChange(notification.id, "time", value)
                }
                slotProps={{
                  textField: {
                    size: "small",
                    sx: { minWidth: 120 },
                  },
                }}
              />
            </LocalizationProvider>
            <IconButton
              size="small"
              color="error"
              onClick={() => onRemoveNotification(notification.id)}
              sx={{
                bgcolor: "#e64a19",
                color: "common.white",
                "&:hover": { bgcolor: "#d84315" },
                borderRadius: "8px",
                ml: 1,
              }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>
        </Grid>
      ))}
      <Grid item xs={12}>
        <Button
          variant="text"
          size="small"
          onClick={onAddNotification}
          sx={{ textTransform: "none", pl: 0 }}
        >
          Add Notification
        </Button>
      </Grid>
    </>
  );
};

NotificationList.propTypes = {
  notifications: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
      amount: PropTypes.number.isRequired,
      unit: PropTypes.string.isRequired,
      time: PropTypes.object,
    })
  ).isRequired,
  onNotificationChange: PropTypes.func.isRequired,
  onRemoveNotification: PropTypes.func.isRequired,
  onAddNotification: PropTypes.func.isRequired,
};

export default NotificationList;
export { notificationUnits };

